import KogInputAmountControlled from "@/main/components/shared/inputText/inputAmountControlled";
import { useFormContext, useWatch } from "react-hook-form";
import { getTranslateByKey } from "@/main/services/utils";
import { QuoteSupplierItemPartResponse } from "@/main/models/response";
import { formatCurrency } from "@/main/services/utilsNumber";
import RenderTooltipMessage from "@/main/components/shared/renderTooltipMessage/renderTooltipMessage";
import { CircularProgress } from "@mui/material";
import * as S from "../../styles";

interface IPriceInputProps {
	fieldPrefix: string;
	showFieldWithouEdit?: boolean;
	row: QuoteSupplierItemPartResponse;
}

export default function ColumnPrice({ fieldPrefix, showFieldWithouEdit, row }: IPriceInputProps) {
	const { control } = useFormContext();

	const watcherNotQuote = useWatch({
		control,
		name: `${fieldPrefix}.notQuote`,
		defaultValue: false,
	});
	const watcherNagsLoading = useWatch({
		control,
		name: `${fieldPrefix}.isNagsLoading`,
		defaultValue: false,
	});
	const watcherNagsLocked = useWatch({
		control,
		name: `${fieldPrefix}.isNagsLocked`,
		defaultValue: false,
	});

	if (showFieldWithouEdit) {
		return row.answeredPrice > 0 ? (
			<S.TextAlignTable>{formatCurrency(Number(row.answeredPrice))}</S.TextAlignTable>
		) : (
			<></>
		);
	}

	const priceInput = (
		<KogInputAmountControlled
			required={!watcherNotQuote}
			typeInput="outlined"
			id="id-createAnswer-txt-answeredPrice"
			name={`${fieldPrefix}.answeredPrice`}
			disabledMessage
			customInputProps={{
				placeholder: getTranslateByKey("information.price"),
			}}
			disabled={watcherNotQuote || watcherNagsLoading || watcherNagsLocked}
			control={control}
			hideValue={watcherNotQuote}
			controllerProps={{
				rules: { maxLength: 10, validate: () => watcherNotQuote },
			}}
		/>
	);

	if (watcherNagsLoading) {
		return (
			<div style={{ position: "relative", width: "100%" }}>
				{priceInput}
				<div
					style={{
						position: "absolute",
						right: 8,
						top: "50%",
						transform: "translateY(-50%)",
						display: "flex",
						alignItems: "center",
						pointerEvents: "none",
					}}
				>
					<CircularProgress size={16} />
				</div>
			</div>
		);
	}

	if (watcherNagsLocked) {
		return (
			<RenderTooltipMessage tooltipMessage={getTranslateByKey("information.nagsConsultFinished")} isWidthChildren>
				{priceInput}
			</RenderTooltipMessage>
		);
	}

	return priceInput;
}
